import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'

import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import 'ant-design-vue/dist/reset.css' // 必须先引入默认样式
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './style.css'
import App from './App.vue'
import router from './router'

// 创建Vue应用实例
const app = createApp(App)

// 创建Pinia实例并配置持久化插件
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用插件
app.use(pinia)
app.use(router)
app.use(ElementPlus, { 
    locale: zhCn,
})

// 挂载应用
app.mount('#app')

// 在应用挂载后初始化用户状态，包括静态菜单和登录状态检查
import { useUserStore } from './stores'
import routeHighlight from './directives/routeHighlight.js'

// 注册全局指令
app.directive('routeHighlight', routeHighlight)

const userStore = useUserStore()
// 初始化用户状态：先初始化静态菜单，再检查登录状态并获取用户菜单数据
userStore.initUserState()
